import { combineReducers } from '@reduxjs/toolkit';
import { faqSlice } from './model/faq';
import { categorySlice } from './model/category';

const faqReducer = combineReducers({
  faq: faqSlice.reducer,
  category: categorySlice.reducer,
});

export default faqReducer;
